import _ from "lodash";

export const emptyFilters = {
  name: null,
};

export const multipleFilters = [];

export const defaultFilters = _.merge({}, emptyFilters, {});

export default {
  proxyPackages: [],
  packageItem: {},
  count: 0,
  pagination: {
    page: 1,
    rowPerPage: 20,
  },
  sort: {
    sortBy: "isActive",
    desc: true,
  },
  filters: _.merge({}, defaultFilters),
};
